// extracted by mini-css-extract-plugin
export var companyLogo = "footer-module--companyLogo--73bd9";
export var container = "footer-module--container--05ec1";
export var content = "footer-module--content--d91e3";